(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofx-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ofx-hero__type').forEach(function (wrap) {
      if (wrap.dataset.ofxHeroInit === '1') return;
      wrap.dataset.ofxHeroInit = '1';

      var textEl = wrap.querySelector('.ofx-hero__type-text');
      var caret  = wrap.querySelector('.ofx-hero__type-caret');
      if (!textEl || !caret) return;

      var raw = (wrap.getAttribute('data-phrases') || '').trim();
      var phrases = raw.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (phrases.length < 2) { return; }

      var TYPE = 55, DEL = 32, HOLD = 3000, START_DELAY = 1600;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
      var current = '';
      var runId = 0;

      function render(s) {
        current = s;
        textEl.innerHTML = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\|/g, ' <br>');
      }

      async function typeStr(s, id) {
        for (var i = 0; i <= s.length; i++) {
          if (id !== runId) return;
          render(s.slice(0, i));
          await sleep(TYPE);
        }
      }

      async function delStr(id) {
        var s = current;
        for (var i = s.length; i >= 0; i--) {
          if (id !== runId) return;
          render(s.slice(0, i));
          await sleep(DEL);
        }
      }

      render(phrases[0]);
      if (reduce) { caret.classList.add('is-hidden'); return; }
      caret.classList.remove('is-hidden');
      var id = ++runId;
      (async function run() {
        await sleep(START_DELAY);
        var idx = 1;
        while (id === runId) {
          await delStr(id); if (id !== runId) return;
          await typeStr(phrases[idx], id); if (id !== runId) return;
          await sleep(HOLD);
          idx = (idx + 1) % phrases.length;
        }
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
